export const toRgba = (rgb: string, alpha: number) => {
    const match = rgb.match(/\d+/g);
    if (!match || match.length < 3) return rgb;
    return `rgba(${match[0]}, ${match[1]}, ${match[2]}, ${alpha})`;
};
